import { jsxs as y, jsx as r, Fragment as se } from "react/jsx-runtime";
import * as M from "react";
import _, { useState as A, useRef as z, useEffect as L, useCallback as T, useMemo as D } from "react";
import { c as b } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { T as j } from "./Typography-DjQwU5Xn.js";
import { P as ne } from "./Progress-C8VQkpiO.js";
import { U as ie } from "./upload-rP6dtNbf.js";
import { C as le, a as ce } from "./zap-CrDt2RgH.js";
import { H as de, R as ue } from "./GuidedTour-BfsVfhC_.js";
import { X as F } from "./x-5QknLR1d.js";
import { A as fe } from "./Alert-CFjABKUQ.js";
import { S as me, B as J, I as pe } from "./Input-s7q1Bymv.js";
import { S as W } from "./search-B4CsPni9.js";
import { B as ge } from "./Badge-CljJSGSb.js";
import { S as he, c as ve, b as ye, d as be, f as xe } from "./Select-BdleKmKb.js";
import { L as we } from "./Section-DbfMk74d.js";
import { E as Ne } from "./DataGrid-C7ruANGS.js";
import { b as Ce, d as Re, e as De, f as Me, g as X, p as V } from "./applier-hnplq_H0.js";
import { defaultValidationRules as ke, validateTree as Ae, groupResultsBySeverity as Te, groupResultsByRule as Pe } from "./presets.js";
import { O as Y, w as Ee, x as Se, y as G, z as Q, B as U, E as Ve, F as Be } from "./KanbanBoard-qgBeD7kn.js";
import { motion as B, AnimatePresence as Z } from "framer-motion";
import { u as $ } from "./motion-D7s_KFf7.js";
import { V as q, R as Oe, A as ee, C as te, a as re, D as oe, P as je } from "./Toast-Bx97RvZK.js";
const Rt = ({
  label: e,
  multiple: t = !1,
  accept: o,
  disabled: s,
  maxSize: d,
  helperText: f,
  uploadFn: n,
  onUploadComplete: i,
  onUploadError: l,
  onAllComplete: u,
  className: p,
  ...h
}) => {
  const [g, v] = A(!1), [x, m] = A([]), w = z(null), P = () => Math.random().toString(36).substring(2, 9), C = async (a) => {
    m((c) => c.map((N) => N.id === a.id ? { ...N, status: "uploading", progress: 0, error: void 0 } : N));
    try {
      const c = await n(a.file, (N) => {
        m((k) => k.map((R) => R.id === a.id ? { ...R, progress: N } : R));
      });
      m((N) => N.map((k) => k.id === a.id ? { ...k, status: "completed", progress: 100, result: c } : k)), i == null || i(a.file, c);
    } catch (c) {
      const N = c instanceof Error ? c.message : "Upload failed";
      m((k) => k.map((R) => R.id === a.id ? { ...R, status: "error", error: N, progress: 0 } : R)), l == null || l(a.file, c instanceof Error ? c : new Error(N));
    }
  }, E = (a) => {
    if (!a) return;
    const c = Array.from(a).filter((R) => !(d && R.size > d));
    if (c.length === 0) return;
    const N = c.map((R) => ({
      file: R,
      id: P(),
      status: "pending",
      progress: 0
    })), k = t ? [...x, ...N] : N;
    m(k), N.forEach((R) => C(R));
  }, I = (a) => {
    a.preventDefault(), a.stopPropagation(), v(!1), !s && a.dataTransfer.files && a.dataTransfer.files.length > 0 && E(a.dataTransfer.files);
  }, O = (a) => {
    a.preventDefault(), a.stopPropagation(), !s && (a.type === "dragenter" || a.type === "dragover" ? v(!0) : a.type === "dragleave" && v(!1));
  }, S = (a) => {
    var c;
    !s && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), (c = w.current) == null || c.click());
  }, K = (a) => {
    m(x.filter((c) => c.id !== a));
  }, H = (a) => {
    C(a);
  };
  return /* @__PURE__ */ y("div", { className: b("flex flex-col gap-4", p), ...h, children: [
    e && /* @__PURE__ */ r("label", { className: "text-sm font-medium text-[var(--ds-color-fg-default)]", children: e }),
    /* @__PURE__ */ y(
      "div",
      {
        className: b(
          "relative flex flex-col items-center justify-center rounded-[var(--ds-radius-lg)] border-2 border-dashed p-8 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-[var(--ds-color-border-primary)]",
          g ? "border-[var(--ds-color-border-primary)] bg-[var(--ds-color-bg-primary-subtle)]" : "border-[var(--ds-color-border-default)] bg-[var(--ds-color-bg-surface-default)] hover:bg-[var(--ds-color-bg-surface-hover)]",
          s && "opacity-50 cursor-not-allowed hover:bg-[var(--ds-color-bg-surface-default)]"
        ),
        onDragEnter: O,
        onDragLeave: O,
        onDragOver: O,
        onDrop: I,
        onClick: () => {
          var a;
          return !s && ((a = w.current) == null ? void 0 : a.click());
        },
        onKeyDown: S,
        tabIndex: s ? -1 : 0,
        role: "button",
        "aria-disabled": s,
        children: [
          /* @__PURE__ */ r(
            "input",
            {
              ref: w,
              type: "file",
              className: "hidden",
              multiple: t,
              accept: o,
              onChange: (a) => E(a.target.files),
              disabled: s
            }
          ),
          /* @__PURE__ */ r(ie, { className: "h-10 w-10 mb-3 text-[var(--ds-color-fg-muted)]" }),
          /* @__PURE__ */ y(j, { variant: "body", className: "text-center font-medium", children: [
            /* @__PURE__ */ r("span", { className: "text-[var(--ds-color-fg-primary)]", children: "Click to upload" }),
            " or drag and drop"
          ] }),
          /* @__PURE__ */ y(j, { variant: "caption", className: "text-[var(--ds-color-fg-muted)] mt-1", children: [
            o ? o.replace(/,/g, ", ") : "Any file",
            " ",
            d && `(max ${(d / 1024 / 1024).toFixed(0)}MB)`
          ] })
        ]
      }
    ),
    x.length > 0 && /* @__PURE__ */ r("div", { className: "space-y-3", children: x.map((a) => /* @__PURE__ */ y("div", { className: "rounded-[var(--ds-radius-md)] border border-[var(--ds-color-border-default)] bg-[var(--ds-color-bg-surface-default)] p-4", children: [
      /* @__PURE__ */ y("div", { className: "flex items-center justify-between mb-2", children: [
        /* @__PURE__ */ y("div", { className: "flex items-center gap-3 overflow-hidden", children: [
          /* @__PURE__ */ r("div", { className: "flex-shrink-0", children: a.status === "completed" ? /* @__PURE__ */ r(le, { className: "h-5 w-5 text-[var(--ds-color-fg-success)]" }) : a.status === "error" ? /* @__PURE__ */ r(ce, { className: "h-5 w-5 text-[var(--ds-color-fg-danger)]" }) : /* @__PURE__ */ r(de, { className: "h-5 w-5 text-[var(--ds-color-fg-muted)]" }) }),
          /* @__PURE__ */ y("div", { className: "min-w-0", children: [
            /* @__PURE__ */ r(j, { variant: "body", className: "text-sm font-medium truncate", children: a.file.name }),
            /* @__PURE__ */ y(j, { variant: "caption", className: "text-[var(--ds-color-fg-subtle)]", children: [
              (a.file.size / 1024).toFixed(1),
              " KB",
              a.status === "error" && ` • ${a.error}`
            ] })
          ] })
        ] }),
        /* @__PURE__ */ y("div", { className: "flex items-center gap-2", children: [
          a.status === "error" && /* @__PURE__ */ r(
            "button",
            {
              onClick: (c) => {
                c.stopPropagation(), H(a);
              },
              className: "p-1 rounded-[var(--ds-radius-sm)] hover:bg-[var(--ds-color-bg-surface-hover)] text-[var(--ds-color-fg-muted)] hover:text-[var(--ds-color-fg-primary)]",
              title: "Retry",
              children: /* @__PURE__ */ r(ue, { className: "h-4 w-4" })
            }
          ),
          /* @__PURE__ */ r(
            "button",
            {
              onClick: (c) => {
                c.stopPropagation(), K(a.id);
              },
              className: "p-1 rounded-[var(--ds-radius-sm)] hover:bg-[var(--ds-color-bg-surface-hover)] text-[var(--ds-color-fg-muted)] hover:text-[var(--ds-color-fg-danger)]",
              title: "Remove",
              children: /* @__PURE__ */ r(F, { className: "h-4 w-4" })
            }
          )
        ] })
      ] }),
      a.status === "uploading" && /* @__PURE__ */ r(ne, { value: a.progress, size: "sm" })
    ] }, a.id)) }),
    f && /* @__PURE__ */ r(j, { variant: "caption", className: "text-[var(--ds-color-fg-muted)]", children: f })
  ] });
}, Le = {
  "bottom-right": "fixed bottom-4 right-4 z-50 max-w-sm w-full animate-in slide-in-from-bottom-2",
  "top-center": "fixed top-4 left-1/2 -translate-x-1/2 z-50 max-w-md w-full animate-in slide-in-from-top-2",
  static: "w-full"
}, Dt = ({
  className: e,
  title: t = "You are offline",
  message: o = "Please check your internet connection.",
  position: s = "bottom-right",
  forceOffline: d = !1
}) => {
  const [f, n] = A(!0);
  return L(() => {
    typeof navigator < "u" && n(navigator.onLine);
    const l = () => n(!0), u = () => n(!1);
    return window.addEventListener("online", l), window.addEventListener("offline", u), () => {
      window.removeEventListener("online", l), window.removeEventListener("offline", u);
    };
  }, []), d || !f ? /* @__PURE__ */ r("div", { className: b(Le[s], e), children: /* @__PURE__ */ r(
    fe,
    {
      variant: "warning",
      title: t,
      description: o,
      icon: /* @__PURE__ */ r("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", className: "w-5 h-5", children: /* @__PURE__ */ r("path", { fillRule: "evenodd", d: "M1.615 2.534a.75.75 0 00-1.06 1.06l2.135 2.135A14.939 14.939 0 00.375 12c0 1.25.163 2.458.47 3.614l1.238-1.238A12.943 12.943 0 011.875 12c0-.936.103-1.84.296-2.711l1.64 1.64c-.024.354-.037.712-.037 1.071 0 .973.109 1.917.316 2.822l1.325-1.325c-.09-.485-.141-.986-.141-1.497 0-.173.006-.343.018-.512l1.838 1.838c-.282.726-.645 1.41-1.077 2.035l1.082 1.082c.584-.731 1.08-1.54 1.464-2.41l1.196 1.196a8.96 8.96 0 01-1.636 1.772l1.246 1.246a10.51 10.51 0 002.324-1.696l2.253 2.253a.75.75 0 001.06-1.06l-16.5-16.5zM15.42 13.297l1.353 1.353c.484-.814.88-1.692 1.173-2.614A12.964 12.964 0 0119.5 12c0 .903-.097 1.78-.281 2.624l1.602 1.602c.319-1.352.493-2.756.493-4.188 0-4.01-1.613-7.636-4.218-10.244a.75.75 0 00-1.06 1.06 13.439 13.439 0 013.778 9.184 13.38 13.38 0 01-.634 4.026l-1.336-1.336a11.966 11.966 0 00.17-2.69 11.927 11.927 0 00-2.476-7.07l-1.09 1.09A10.428 10.428 0 0117.625 12c0 .668-.07 1.32-.205 1.954V13.297zM11.698 9.578l2.96 2.96c.038-.176.059-.356.059-.538 0-1.286-.888-2.358-2.096-2.597.025.267.06.53.106.79.034.205.061.41.08.614l-1.11-1.23z", clipRule: "evenodd" }) })
    }
  ) }) : null;
}, Ie = _.forwardRef(
  ({ value: e, onChange: t, onSearch: o, onClear: s, isLoading: d, className: f, ...n }, i) => {
    const l = (h) => {
      var g;
      h.key === "Enter" && o && o(e), (g = n.onKeyDown) == null || g.call(n, h);
    }, p = d ? /* @__PURE__ */ r(me, { size: "sm", className: "h-4 w-4" }) : e ? /* @__PURE__ */ r(
      J,
      {
        variant: "ghost",
        size: "sm",
        className: "h-6 w-6 p-0 hover:bg-transparent text-muted-foreground hover:text-foreground",
        onClick: () => {
          t(""), s == null || s();
        },
        "aria-label": "Clear search",
        children: /* @__PURE__ */ r(F, { className: "h-4 w-4" })
      }
    ) : n.rightElement;
    return /* @__PURE__ */ r(
      pe,
      {
        ref: i,
        value: e,
        onChange: (h) => t(h.target.value),
        onKeyDown: l,
        leftElement: /* @__PURE__ */ r(W, { className: "h-4 w-4" }),
        rightElement: p,
        type: "search",
        className: b("w-full", f),
        ...n
      }
    );
  }
);
Ie.displayName = "SearchBar";
const Mt = ({
  filters: e,
  activeFilters: t,
  onFilterChange: o,
  onClearFilter: s,
  onClearAll: d,
  className: f
}) => {
  const n = Object.keys(t).length;
  return /* @__PURE__ */ y("div", { className: b("space-y-4", f), children: [
    /* @__PURE__ */ y("div", { className: "flex flex-wrap gap-2 items-center", children: [
      e.map((i) => /* @__PURE__ */ y(
        he,
        {
          value: t[i.id],
          onValueChange: (l) => o(i.id, l),
          children: [
            /* @__PURE__ */ r(ve, { className: "w-[180px]", children: /* @__PURE__ */ r(ye, { placeholder: i.label }) }),
            /* @__PURE__ */ r(be, { children: i.options.map((l) => /* @__PURE__ */ r(xe, { value: l.value, children: l.label }, l.value)) })
          ]
        },
        i.id
      )),
      n > 0 && /* @__PURE__ */ r(J, { variant: "ghost", size: "sm", onClick: d, className: "h-10 px-3", children: "Clear all" })
    ] }),
    n > 0 && /* @__PURE__ */ r("div", { className: "flex flex-wrap gap-2", children: Object.entries(t).map(([i, l]) => {
      const u = e.find((g) => g.id === i);
      if (!u) return null;
      const p = u.options.find((g) => g.value === l), h = p ? p.label : l;
      return /* @__PURE__ */ y(
        ge,
        {
          variant: "gray",
          size: "md",
          removable: !0,
          onRemove: () => s(i),
          children: [
            /* @__PURE__ */ y("span", { className: "text-muted-foreground mr-1", children: [
              u.label,
              ":"
            ] }),
            h
          ]
        },
        i
      );
    }) })
  ] });
}, kt = ({
  items: e,
  renderItem: t,
  isLoading: o,
  emptyTitle: s = "No results found",
  emptyDescription: d = "Try adjusting your search or filters to find what you are looking for.",
  emptyIcon: f = /* @__PURE__ */ r(W, {}),
  customEmptyState: n,
  layout: i = "list",
  gridClassName: l = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  className: u
}) => o ? /* @__PURE__ */ r(we, { className: u }) : !e || e.length === 0 ? n ? /* @__PURE__ */ r(se, { children: n }) : /* @__PURE__ */ r(
  Ne,
  {
    title: s,
    description: d,
    icon: f,
    className: u
  }
) : /* @__PURE__ */ r(
  "div",
  {
    className: b(
      i === "grid" ? `grid gap-6 ${l}` : "flex flex-col gap-4",
      u
    ),
    children: e.map((p, h) => /* @__PURE__ */ r(_.Fragment, { children: t(p, h) }, h))
  }
), At = ({
  data: e,
  columns: t,
  permissionCheck: o
}) => {
  const s = T(
    (n) => n ? o ? o(n) : !1 : !0,
    [o]
  ), d = T(
    (n = {}) => {
      const { fileName: i = "export", permission: l } = n;
      if (!s(l)) {
        console.warn("Export permission denied");
        return;
      }
      const u = t.map((m) => m.header).join(","), p = e.map(
        (m) => t.map((w) => {
          const P = m[w.key], C = P == null ? "" : String(P);
          return C.includes(",") || C.includes('"') || C.includes(`
`) ? `"${C.replace(/"/g, '""')}"` : C;
        }).join(",")
      ), h = [u, ...p].join(`
`), g = new Blob([h], { type: "text/csv;charset=utf-8;" });
      if (typeof document > "u") {
        console.warn("Export is only available in browser environment");
        return;
      }
      const v = document.createElement("a"), x = URL.createObjectURL(g);
      v.setAttribute("href", x), v.setAttribute("download", `${i}.csv`), v.style.visibility = "hidden", document.body.appendChild(v), v.click(), document.body.removeChild(v);
    },
    [e, t, s]
  ), f = T(
    (n = {}) => {
      const { fileName: i = "export", permission: l } = n;
      if (!s(l)) {
        console.warn("Export permission denied");
        return;
      }
      const u = e.map((x) => {
        const m = {};
        return t.forEach((w) => {
          m[w.key] = x[w.key];
        }), m;
      }), p = JSON.stringify(u, null, 2), h = new Blob([p], { type: "application/json" });
      if (typeof document > "u") {
        console.warn("Export is only available in browser environment");
        return;
      }
      const g = document.createElement("a"), v = URL.createObjectURL(h);
      g.setAttribute("href", v), g.setAttribute("download", `${i}.json`), g.style.visibility = "hidden", document.body.appendChild(g), g.click(), document.body.removeChild(g);
    },
    [e, t, s]
  );
  return {
    exportToCSV: d,
    exportToJSON: f
  };
};
function Tt(e) {
  const { presetId: t, overrides: o, autoApply: s = !1 } = e, [d, f] = A(null), [n, i] = A(!0), [l, u] = A(!1), p = D(() => {
    i(!0), f(null);
    try {
      const m = Ce(t, o);
      return i(!1), m;
    } catch (m) {
      return f(m), i(!1), null;
    }
  }, [t, o]), h = T(() => {
    if (!(typeof document > "u"))
      try {
        Re(t, { overrides: o }), u(!0);
      } catch (m) {
        f(m);
      }
  }, [t, o]), g = T(() => {
    typeof document > "u" || (De(), u(!1));
  }, []);
  L(() => (s && p && h(), () => {
    s && l && g();
  }), [s, p, h, g, l]), L(() => {
    if (typeof document < "u") {
      const m = Me() === t;
      u(m);
    }
  }, [t]);
  const v = T(
    (m) => X(t, m),
    [t]
  ), x = D(() => (p == null ? void 0 : p.computedCssVariables) || {}, [p]);
  return {
    preset: p,
    error: d,
    isLoading: n,
    isApplied: l,
    apply: h,
    remove: g,
    getDefaults: v,
    cssVariables: x
  };
}
function Pt() {
  return D(() => V.getAll(), []);
}
function Et(e) {
  return D(() => V.getByCategory(e), [e]);
}
function St(e) {
  return D(() => e.trim() ? V.search(e) : V.getAll(), [e]);
}
function Vt(e, t = 5) {
  return D(() => V.findSimilar(e, t), [e, t]);
}
function Bt(e) {
  return D(() => V.get(e), [e]);
}
function Ot(e, t, o) {
  return D(() => o ? {
    ...X(o, e),
    ...t
  } : t, [e, t, o]);
}
function ze(e) {
  const {
    presetId: t,
    customRules: o = [],
    enabled: s = !0,
    devOnly: d = !0,
    root: f = typeof document < "u" ? document.body : null,
    debounceMs: n = 100,
    onViolation: i,
    includeInfo: l = !1
  } = e, [u, p] = A([]), [h, g] = A(!1), v = z(null), x = z(null), m = z(i);
  m.current = i;
  const w = D(() => V.get(t) || null, [t]), P = D(() => [...ke, ...o], [o]), C = D(() => {
    var c;
    return !(!s || d && typeof process < "u" && ((c = process.env) == null ? void 0 : c.NODE_ENV) !== "development" || !w || typeof document > "u");
  }, [s, d, w]), E = T(() => {
    if (!C || !f || !w) {
      p([]);
      return;
    }
    g(!0);
    try {
      const c = Ae(f, w, {
        rules: P,
        includeInfo: l
      });
      p(c), c.length > 0 && m.current && m.current(c);
    } catch (c) {
      console.error("Preset validation error:", c);
    } finally {
      g(!1);
    }
  }, [C, f, w, P, l]), I = T(() => {
    x.current && clearTimeout(x.current), x.current = setTimeout(E, n);
  }, [E, n]), O = T(() => {
    p([]);
  }, []);
  L(() => {
    if (!(!C || !f))
      return E(), v.current = new MutationObserver(() => {
        I();
      }), v.current.observe(f, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["class", "style", "data-component", "data-variant"]
      }), () => {
        v.current && (v.current.disconnect(), v.current = null), x.current && (clearTimeout(x.current), x.current = null);
      };
  }, [C, f, E, I]);
  const S = D(() => Te(u), [u]), K = D(() => Pe(u), [u]), H = S.error.length > 0, a = S.warning.length > 0;
  return {
    violations: u,
    bySeverity: S,
    byRule: K,
    hasErrors: H,
    hasWarnings: a,
    violationCount: u.length,
    errorCount: S.error.length,
    warningCount: S.warning.length,
    validate: E,
    clear: O,
    isValidating: h,
    preset: w
  };
}
function jt(e) {
  const { containerRef: t, ...o } = e, [s, d] = A(null);
  return L(() => {
    d(t.current);
  }, [t]), ze({ ...o, root: s });
}
const Fe = ({
  children: e,
  ...t
}) => /* @__PURE__ */ r(Be, { ...t, children: e }), $e = Ve, Lt = G, Ke = Ee, ae = M.forwardRef(({ className: e, ...t }, o) => {
  const { durations: s, easings: d } = $();
  return /* @__PURE__ */ r(Y, { asChild: !0, children: /* @__PURE__ */ r(
    B.div,
    {
      ref: o,
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: s.fast, ease: d.out },
      className: b(
        "fixed inset-0 z-50 bg-black/80",
        e
      ),
      ...t
    }
  ) });
});
ae.displayName = Y.displayName;
const He = M.forwardRef(({ className: e, children: t, ...o }, s) => {
  const { durations: d, easings: f } = $();
  return /* @__PURE__ */ y(Ke, { forceMount: !0, children: [
    /* @__PURE__ */ r(ae, {}),
    /* @__PURE__ */ r(Se, { asChild: !0, children: /* @__PURE__ */ y(
      B.div,
      {
        ref: s,
        initial: { opacity: 0, scale: 0.95, x: "-50%", y: "-45%" },
        animate: { opacity: 1, scale: 1, x: "-50%", y: "-50%" },
        exit: { opacity: 0, scale: 0.95, x: "-50%", y: "-45%" },
        transition: { duration: d.normal, ease: f.spring },
        className: b(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-[var(--density-gap)] border bg-surface p-[calc(var(--density-padding)*1.5)] shadow-elevation-3 sm:rounded-[var(--shape-radius-2xl)]",
          e
        ),
        ...o,
        children: [
          t,
          /* @__PURE__ */ y(G, { className: "absolute right-[var(--density-padding)] top-[var(--density-padding)] rounded-[var(--shape-radius-sm)] opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
            /* @__PURE__ */ r(F, { className: "h-4 w-4" }),
            /* @__PURE__ */ r("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    ) })
  ] });
});
He.displayName = "MotionDialogContent";
const _e = ({
  className: e,
  ...t
}) => /* @__PURE__ */ r(
  "div",
  {
    className: b(
      "flex flex-col space-y-[calc(var(--density-gap)*0.75)] text-center sm:text-start",
      e
    ),
    ...t
  }
);
_e.displayName = "MotionDialogHeader";
const Je = ({
  className: e,
  ...t
}) => /* @__PURE__ */ r(
  "div",
  {
    className: b(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-[var(--density-gap)]",
      e
    ),
    ...t
  }
);
Je.displayName = "MotionDialogFooter";
const We = M.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ r(
  Q,
  {
    ref: o,
    className: b(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
We.displayName = Q.displayName;
const Xe = M.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ r(
  U,
  {
    ref: o,
    className: b("text-sm text-muted-foreground", e),
    ...t
  }
));
Xe.displayName = U.displayName;
const It = ({
  open: e,
  onOpenChange: t,
  trigger: o,
  children: s
}) => /* @__PURE__ */ y(Fe, { open: e, onOpenChange: t, children: [
  o && /* @__PURE__ */ r($e, { asChild: !0, children: o }),
  /* @__PURE__ */ r(Z, { children: e && s })
] }), zt = je, Ye = M.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ r(
  q,
  {
    ref: o,
    className: b(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      "sm:end-0",
      e
    ),
    ...t
  }
));
Ye.displayName = q.displayName;
const Ge = M.forwardRef(({ className: e, ...t }, o) => {
  const { durations: s, easings: d } = $();
  return /* @__PURE__ */ r(
    Oe,
    {
      type: "foreground",
      defaultOpen: !0,
      ...t,
      asChild: !0,
      forceMount: !0,
      children: /* @__PURE__ */ r(
        B.li,
        {
          ref: o,
          layout: !0,
          initial: { opacity: 0, x: 300, scale: 0.9 },
          animate: { opacity: 1, x: 0, scale: 1 },
          exit: { opacity: 0, scale: 0.9, transition: { duration: s.fast } },
          transition: {
            type: "spring",
            stiffness: 400,
            damping: 40,
            opacity: { duration: s.fast },
            layout: { duration: s.normal, ease: d.smooth }
          },
          className: b(
            "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pe-8 shadow-elevation-3 transition-all",
            "bg-surface text-foreground border-border",
            e
          )
        }
      )
    }
  );
});
Ge.displayName = "MotionToast";
const Qe = M.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ r(
  ee,
  {
    ref: o,
    className: b(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary-hover focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none group-[.destructive]:border-destructive group-[.destructive]:hover:border-destructive group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
Qe.displayName = ee.displayName;
const Ue = M.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ r(
  te,
  {
    ref: o,
    className: b(
      "absolute right-2 top-2 rounded-md p-1 text-muted-foreground opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-destructive-foreground group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive group-[.destructive]:focus:ring-offset-destructive rtl:left-2 rtl:right-auto",
      e
    ),
    "toast-close": "",
    "aria-label": "Close",
    ...t,
    children: /* @__PURE__ */ r(F, { className: "h-4 w-4" })
  }
));
Ue.displayName = te.displayName;
const Ze = M.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ r(
  re,
  {
    ref: o,
    className: b("text-sm font-semibold", e),
    ...t
  }
));
Ze.displayName = re.displayName;
const qe = M.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ r(
  oe,
  {
    ref: o,
    className: b("text-sm opacity-90", e),
    ...t
  }
));
qe.displayName = oe.displayName;
function Ft({
  items: e,
  getKey: t,
  renderItem: o,
  emptyMessage: s,
  className: d,
  ...f
}) {
  const { durations: n, easings: i } = $();
  return /* @__PURE__ */ r(
    B.ul,
    {
      className: b("flex flex-col gap-2", d),
      ...f,
      children: /* @__PURE__ */ r(Z, { initial: !1, mode: "popLayout", children: e.length === 0 && s ? /* @__PURE__ */ r(
        B.li,
        {
          initial: { opacity: 0, height: 0 },
          animate: { opacity: 1, height: "auto" },
          exit: { opacity: 0, height: 0 },
          transition: { duration: n.normal, ease: i.smooth },
          children: s
        },
        "empty"
      ) : e.map((l, u) => /* @__PURE__ */ r(
        B.li,
        {
          layout: !0,
          initial: { opacity: 0, scale: 0.8, y: 10 },
          animate: { opacity: 1, scale: 1, y: 0 },
          exit: { opacity: 0, scale: 0.8, transition: { duration: n.fast } },
          transition: {
            duration: n.normal,
            ease: i.spring,
            layout: { duration: n.normal, ease: i.smooth }
          },
          children: o(l, u)
        },
        t(l)
      )) })
    }
  );
}
export {
  qe as A,
  Ue as B,
  Qe as C,
  Ft as D,
  Rt as F,
  Fe as M,
  Dt as O,
  Ie as S,
  Pt as a,
  Et as b,
  St as c,
  Vt as d,
  Bt as e,
  Ot as f,
  ze as g,
  jt as h,
  Mt as i,
  kt as j,
  At as k,
  Ke as l,
  ae as m,
  $e as n,
  Lt as o,
  He as p,
  _e as q,
  Je as r,
  We as s,
  Xe as t,
  Tt as u,
  It as v,
  zt as w,
  Ye as x,
  Ge as y,
  Ze as z
};
